"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ShippingSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.993279,4.8824955 L11,4.999 L13.123122,4.99973793 C13.5694735,4.99989306 13.9616762,5.29583906 14.0842983,5.72501674 L14.980762,8.86263944 L14.9954088,8.93193147 L15,9 L15,12 C15,12.5128358 14.6139598,12.9355072 14.1166211,12.9932723 L14,13 C14,14.1045695 13.1045695,15 12,15 C10.8954305,15 10,14.1045695 10,13 L7,13 C7,14.1045695 6.1045695,15 5,15 C3.8954305,15 3,14.1045695 3,13 L2,13 L2,12 L3.26760632,11.9999275 C3.61342606,11.4021661 4.25974756,11 5,11 C5.74025244,11 6.38657394,11.4021661 6.73239368,11.9999275 L10.2676063,11.9999275 C10.6134261,11.4021661 11.2597476,11 12,11 C12.7402524,11 13.3865739,11.4021661 13.7323937,11.9999275 L14,12 L14,10 L10,10 L10,5 L2,5 L2,4 L10.001,4 C10.513323,4 10.9355717,4.38565415 10.993279,4.8824955 Z M5,12 C4.44771525,12 4,12.4477153 4,13 C4,13.5522847 4.44771525,14 5,14 C5.55228475,14 6,13.5522847 6,13 C6,12.4477153 5.55228475,12 5,12 Z M12,12 C11.4871642,12 11.0644928,12.3860402 11.0067277,12.8833789 L11,13 C11,13.5522847 11.4477153,14 12,14 C12.5522847,14 13,13.5522847 13,13 C13,12.4477153 12.5522847,12 12,12 Z M6,9 L6,10 L2,10 L2,9 L6,9 Z M13.123,6 L11,5.999 L11,9 L13.98,9 L13.123,6 Z M6,6 L6,7 L2,7 L2,6 L6,6 Z" })));
};
ShippingSmall.displayName = 'ShippingSmall';
exports.default = ShippingSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ShippingSmall.js.map